import { api } from './client'

const contactService = {
  getContacts: async ({ limit = 50, offset = 0, searchTerm } = {}) => {
    const params = { limit, offset }
    if (searchTerm) params.q = searchTerm
    const resp = await api.get('/contacts', params)
    return { contacts: resp.data, total: resp.meta.total }
  },

  getContact: async (contactId) => {
    const resp = await api.get(`/contacts/${contactId}`)
    return resp.data
  },

  createContact: async (contactData) => {
    const resp = await api.post('/contacts', contactData)
    return resp.data
  },

  updateContact: async (contactId, contactData) => {
    const resp = await api.put(`/contacts/${contactId}`, contactData)
    return resp.data
  },

  archiveContact: async (contactId) => {
    const resp = await api.put(`/contacts/${contactId}`, { status: 'Inactive' })
    return resp.data
  },
}

export default contactService
